<template>
  <div class="asc-health-score-bar-chart">
    <div>
      <div class="asc-health-score-bar-chart--header">
        <asc-header
          class="asc-health-score-bar-chart--header-title"
          uppercase
          size="h4"
          :value="title"
        />
        <template v-if="tooltip.length">
          <asc-tooltip
            :tooltip="tooltip"
            bottom
            is-icon-tooltip
            :max-width="'300'"
            class="asc-health-score-bar-chart--header-tooltip"
          >
            <span class="asc-icon">
              <v-icon class="icon-info" :size="20">mdi-information</v-icon>
            </span>
          </asc-tooltip>
        </template>
      </div>

      <asc-fleet-bar-chart
        class="asc-health-score-bar-chart--container"
        :tails="tails"
        :loading="loading"
        :series-data="getSeries"
        :selected-item="selectedItem"
        :type="type"
        @onSeriesClick="handleRowClicked"
      ></asc-fleet-bar-chart>

      <template v-if="tails.length && showButton && !showAllTails && !loading">
        <div class="asc-health-score-bar-chart--all-tails-button">
          <asc-accent-button
            button-text="See All Tails"
            secondary
            :on-click="handleSeeAllTailsClicked"
            icon="mdi-chevron-down"
            icon-position="left"
          ></asc-accent-button>
        </div>
      </template>
      <template v-if="tails.length && showButton & showAllTails && !loading">
        <div class="asc-health-score-bar-chart--all-tails-button">
          <asc-accent-button
            button-text="Collapse All Tails"
            secondary
            :on-click="handleCollapseAllTailsClicked"
            icon="mdi-chevron-up"
            icon-position="left"
          ></asc-accent-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import AscAccentButton from '../atoms/AscAccentButton.vue'
import AscTooltip from '@/components/atoms/AscTooltip'
import AscHeader from '@/components/atoms/AscHeader'
import AscFleetBarChart from './AscFleetBarChart.vue'

export default {
  name: 'AscHealthScoreBarChart',

  components: {
    AscAccentButton,
    AscTooltip,
    AscHeader,
    AscFleetBarChart,
  },

  props: {
    values: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    selectedItem: {
      type: String,
      default: '',
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      showAllTails: false,
      tails: [],
    }
  },

  computed: {
    getSeries() {
      if (this.type === 'healthTail') {
        return [
          {
            name: 'Health scores below 1',
            data: this.tails.length
              ? this.tails.map(item => item.lowScoreSummation)
              : [],
            color: '#53B8B3',
          },
          {
            name: 'Health scores at or above 1',
            data: this.tails.length
              ? this.tails.map(item => item.highScoreSummation)
              : [],
            color: '#D20532',
          },
        ]
      }
      return [
        {
          name: 'Health scores for tail',
          data: this.tails.length ? this.tails.map(item => item.riskScore) : [],
        },
      ]
    },
  },

  watch: {
    values: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.tails =
          this.showAllTails || !this.showButton ? newVal : newVal.slice(0, 15)
      },
    },
  },

  methods: {
    handleSeeAllTailsClicked() {
      this.showAllTails = true
      this.tails = this.values
    },

    handleCollapseAllTailsClicked() {
      this.showAllTails = false
      this.tails = this.values.slice(0, 15)
    },

    handleRowClicked(data) {
      this.$emit('onSeriesClick', data)
    },
  },
}
</script>

<style lang="scss">
.asc-health-score-bar-chart {
  .asc-health-score-bar-chart--all-tails-button {
    padding: 0 12px;
  }

  .asc-accent-button-container .asc-accent-button--accent.theme--light.v-btn {
    width: 100%;
  }

  .asc-icon {
    display: inline-block;
    top: -2px;
    padding-left: $spacing-sm;
    position: relative;
  }

  .asc-icon .icon-info {
    color: $accent-500;
    cursor: pointer;
    display: inline-block;
    font-size: $font-size-lrg;
  }

  .asc-health-score-bar-chart {
    &--container {
      padding: 0 10px;
      height: 350px;
      overflow-y: auto;
    }

    &--header {
      display: flex;
      padding-top: 10px;
      padding-left: 10px;

      &-title {
        & .asc-header--h4 {
          font-size: 16px !important;
          font-weight: 500 !important;
          line-height: 18px !important;
          letter-spacing: 1px !important;
        }
      }
    }
  }
}
</style>
